// Users
export const SUBSCRIPTION_FREE = 'FREE';
export const SUBSCRIPTION_BRONZE = 'BRONZE';
export const SUBSCRIPTION_SILVER = 'SILVER';
export const SUBSCRIPTION_GOLD = 'GOLD';
export const SUBSCRIPTION_PLATINUM = 'PLATINUM';
